exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\n* IBM Confidential\n* OCO Source Materials\n* IBM Business Platform: Dashboard\n* (C) Copyright IBM Corp. 2019\n* The source code for this program is not published or otherwise divested of its trade secrets,\n* irrespective of what has been deposited with the U.S. Copyright Office\n**/\n\n.recommended-comparison {\n  min-height: 180px;\n  padding-bottom: 16px;\n}\n\n.recommended-comparison__section__header__container {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  padding: 16px 0 8px 8px;\n}\n\n.recommended-comparison__section__header__container__column {\n  padding-left: 3px;\n  font-weight: bold;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/postcss-loader??ref--2-2!./node_modules/resolve-url-loader!./node_modules/sass-loader/lib/loader.js??ref--2-4!./src/js/components/compareChooser/ComparisonRecommendations.scss
// module id = 306
// module chunks = 0